import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {take, tap} from 'rxjs/operators';
import {filterNullOrUndefined} from '../../common/service';
import {ProductComponentModel, ProductType} from '../../data/model';
import {hideLoadingIndicator, showLoadingIndicator} from '../add-on.actions';
import {selectAddonByCatalogId} from '../reducers';

/**
 * Resolver to load a specific add-on by catalog id.
 * @param route The route snapshot.
 */
export const resolveAddon: ResolveFn<
  ProductComponentModel<ProductType> | undefined
> = () => {
  const store: Store = inject(Store);
  store.dispatch(showLoadingIndicator());

  return store.pipe(
    select(selectAddonByCatalogId),
    filterNullOrUndefined(),
    take(1),
    tap(() => store.dispatch(hideLoadingIndicator())),
  );
};
